import { initializeApp, getApp, getApps } from "firebase/app";
import { getMessaging, getToken, isSupported, Messaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAGDrRYf3dcdGaoj4Wq_6W8FK2b-id5_6w",
  authDomain: "templedekhodev.firebaseapp.com",
  databaseURL: "https://templedekhodev-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "templedekhodev",
  storageBucket: "templedekhodev.appspot.com",
  messagingSenderId: "844085093093",
  appId: "1:844085093093:web:772c9fe317b3e27b092a0c",
  measurementId: "G-2RB5NWFH8B"
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Lazily initialized — only created after isSupported() confirms the environment supports it.
let _messagingInstance: Messaging | null = null;

/**
 * Returns a Firebase Messaging instance, or null if the current environment
 * does not support it (e.g. iOS WKWebView which lacks Service Worker support).
 */
export const getMessagingInstance = async (): Promise<Messaging | null> => {
  if (_messagingInstance) return _messagingInstance;
  try {
    const supported = await isSupported();
    if (supported) {
      _messagingInstance = getMessaging(app);
      return _messagingInstance;
    }
  } catch (err) {
    console.warn("Firebase Messaging is not supported in this environment:", err);
  }
  return null;
};

// const VAPID_KEY = "BFuk9RYjf_lme9gra8XrL2MOVZOIjlRs1ShSlh171njSsX-2U9SnyPN_5QuT55K0fPD9x45MaTGIegOavdYL0u8";
const VAPID_KEY = "BDRAPoes0BKkp0wL2z3Xpv1Sxvhmm4we8g4P_j_5tlh6ss82sdHKKCg-9yTgnkcUNXoQLCG8UNdC8GyICsLsumw";


export const requestForToken = async (): Promise<string | null> => {
  try {
    const messaging = await getMessagingInstance();
    if (!messaging) {
      console.warn("Firebase Messaging is not supported — skipping token request.");
      return null;
    }

    let registration: ServiceWorkerRegistration | undefined = undefined;

    if ('serviceWorker' in navigator) {
      // 1. Kick off the registration
      await navigator.serviceWorker.register('/firebase-messaging-sw.js');

      // 2. CRITICAL: Wait until the service worker is active and ready
      registration = await navigator.serviceWorker.ready;
    }

    // 3. Pass the guaranteed active registration to Firebase
    const currentToken = await getToken(messaging, { 
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration 
    });

    if (currentToken) {
      return currentToken;
    }
    
    console.warn("No registration token available.");
    return null;
  } catch (err) {
    console.error("An error occurred while retrieving token: ", err);
    return null;
  }
};